import { getMobileAppEnvironment } from '@tbitop/environment/mobile-app';
import type { StageParameters } from '@tbitop/environment/stage-parameters';
import { appConfig } from './app-config';

const stageParameters: StageParameters = {
  baseUrl: process.env.NEXT_PUBLIC_BASE_URL ?? '',
  authenticationBaseUrl: process.env.NEXT_PUBLIC_AUTH_BASE_URL,
  instrumentationKey: process.env.NEXT_PUBLIC_INSTRUMENTATION_KEY ?? '',
};

export const environment = getMobileAppEnvironment(stageParameters, appConfig);
